import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { ConditionalCheckForm } from './ConditionCheckForm';
import {
  Alert,
  type AlertDetails,
  Loading,
} from '../../../../../../components';
import {
  useGetConditionMeet,
  useSubmitConditionMeet,
  type Conditions,
} from '../../../../graphql';

type ConditionCheckContentProps = {
  viewMode?: boolean;
};

export const ConditionCheckContent: React.FC<ConditionCheckContentProps> = (
  props: ConditionCheckContentProps,
) => {
  const { viewMode = false } = props;
  const { applicationId } = useParams();
  const [openAlert, setOpenAlert] = useState(false);
  const [alertDetails, setAlertDetails] = useState<AlertDetails>({
    alertContent: '',
    alertType: 'error',
  });

  const { conditionMeet, registrationDeadline, loading, error } =
    useGetConditionMeet(applicationId as string);

  const submitConditionMeet = useSubmitConditionMeet();
  const handleSubmitConditionMeet = async (
    values: Conditions,
  ): Promise<void> => {
    const {
      conditions,
      contactPerson: { deadline, personName, personEmail, personPhone },
    } = values;
    try {
      await submitConditionMeet({
        variables: {
          input: {
            applicationId,
            condition: conditions,
            conditionFulfillingDeadline: deadline,
            contactDepartmentPersonName: personName,
            contactDepartmentPersonEmail: personEmail,
            contactDepartmentPersonPhone: personPhone,
          },
        },
      });

      setAlertDetails({
        alertContent: 'Submitted Condition Check Successfully. ',
        alertType: 'success',
      });
    } catch (error: any) {
      setAlertDetails({
        alertContent: error.message,
        alertType: 'error',
      });
    }

    setOpenAlert(true);
  };

  if (error) {
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }

  return (
    <>
      <Alert
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        alertDetails={alertDetails}
      />
      {loading ? (
        <Loading />
      ) : (
        <ConditionalCheckForm
          viewMode={viewMode}
          conditionMeet={conditionMeet}
          registrationDeadline={registrationDeadline}
          submitConditionMeet={handleSubmitConditionMeet}
        />
      )}
    </>
  );
};
